import React, { useState } from "react";


import {
  FaFilm,
  FaChevronDown,
  FaChevronUp,
  FaCheck,
} from "react-icons/fa";

function MediaEntertainmentPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "Content Creation & Production",
      points: [
        "Script Generation Agent",
        "Storyboard Assistant Bot",
        "AI Video Editing Agent",
        "Soundtrack Recommender Bot",
        "Voice Cloning for Dubbing",
      ],
    },

    {
      title: "Content Personalization & Delivery",
      points: [
        "Personalized Show Recommender",
        "Smart Content Playlist Curator",
        "Mood-Based Content Agent",
        "User Engagement Pattern Analyzer",
        "Regional Content Localization Bot",
      ],
    },

    {
      title: "Audience Intelligence",
      points: [
        "Sentiment Analysis on Shows",
        "Viewer Retention Analyzer",
        "Fandom Trend Tracker",
        "Subscription Churn Prediction Agent",
        "Feedback Analyzer from Social Media",
      ],
    },

    {
      title: "Content Moderation & Rights",
      points: [
        "Copyright Infringement Detection Bot",
        "Plagiarism Checker for Scripts",
        "Offensive Content Detection Agent",
        "Fake News Detection Agent",
        "Deepfake Detection Bot",
      ],
    },

    {
      title: "Talent & Marketing",
      points: [
        "Influencer Collaboration Matcher",
        "Fanbase Growth Strategy Agent",
        "Actor Portfolio Analyzer",
        "Marketing Campaign Planner Agent",
        "Social Media Engagement Optimizer",
      ],
    },
  ];

  return (
    <>

      {/* Responsive styles for this page */}
      <style>{`
        .media-wrapper {
          background: #22c7b8;
          min-height: 100vh;
        }

        .media-hero {
          background: #173b8f;
          width: 100%;
        }

        .media-hero-inner {
          width: 92%;
          max-width: 1300px;
          margin: 0 auto;
          padding: 38px 0px;
        }

        .media-hero-top {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
        }

        .media-icon-box {
          width: 44px;
          height: 44px;
          background: #22c7b8;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .media-icon-box svg {
          color: #ffffff;
          font-size: 20px;
        }

        .media-title {
          color: #ffffff;
          font-size: 34px;
          font-weight: 700;
          margin: 0;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .media-description {
          color: #f2f2f2;
          font-size: 15px;
          line-height: 1.9;
          max-width: 1000px;
          margin: 0;
        }

        .media-accordion-wrap {
          width: 92%;
          max-width: 1050px;
          margin: 0 auto;
          padding: 28px 0px 50px;
        }

        .media-card {
          background: #ffffff;
          border-radius: 8px;
          margin-bottom: 10px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        .media-card-header {
          padding: 14px 18px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          transition: 0.3s;
          gap: 10px;
        }

        .media-card-header.active {
          background: #173b8f;
        }

        .media-card-header.inactive {
          background: #ffffff;
        }

        .media-card-title {
          margin: 0;
          font-size: 16px;
          font-weight: 700;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .media-card-title.active {
          color: #ffffff;
        }

        .media-card-title.inactive {
          color: #173b8f;
        }

        .media-chevron-active {
          color: #ffffff;
          font-size: 16px;
          flex-shrink: 0;
        }

        .media-chevron-inactive {
          color: #173b8f;
          font-size: 16px;
          flex-shrink: 0;
        }

        .media-card-content {
          padding: 18px 24px;
          background: #ffffff;
        }

        .media-point-row {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 12px;
        }

        .media-point-check {
          width: 24px;
          height: 24px;
          min-width: 24px;
          border-radius: 50%;
          background: #22c7b8;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .media-point-check svg {
          color: #ffffff;
          font-size: 10px;
        }

        .media-point-text {
          margin: 0;
          color: #4b5563;
          font-size: 15px;
          line-height: 1.7;
          font-weight: 500;
          word-break: break-word;
        }

        /* Tablets */
        @media (max-width: 1024px) {
          .media-hero-inner {
            padding: 32px 0px;
          }

          .media-title {
            font-size: 30px;
          }

          .media-accordion-wrap {
            width: 90%;
          }
        }

        /* Small tablets / large phones */
        @media (max-width: 768px) {
          .media-hero-inner {
            width: 90%;
            padding: 26px 0px;
          }

          .media-icon-box {
            width: 40px;
            height: 40px;
          }

          .media-icon-box svg {
            font-size: 18px;
          }

          .media-title {
            font-size: 26px;
          }

          .media-description {
            font-size: 14px;
            line-height: 1.8;
          }

          .media-accordion-wrap {
            width: 90%;
            padding: 22px 0px 40px;
          }

          .media-card-header {
            padding: 12px 16px;
          }

          .media-card-title {
            font-size: 15px;
          }

          .media-card-content {
            padding: 16px 18px;
          }
        }

        /* Mobile phones */
        @media (max-width: 480px) {
          .media-hero-inner {
            width: 88%;
            padding: 22px 0px;
          }

          .media-hero-top {
            gap: 10px;
            margin-bottom: 12px;
          }

          .media-icon-box {
            width: 36px;
            height: 36px;
            border-radius: 8px;
          }

          .media-icon-box svg {
            font-size: 16px;
          }

          .media-title {
            font-size: 21px;
          }

          .media-description {
            font-size: 13px;
            line-height: 1.7;
          }

          .media-accordion-wrap {
            width: 90%;
            padding: 18px 0px 32px;
          }

          .media-card {
            border-radius: 6px;
            margin-bottom: 8px;
          }

          .media-card-header {
            padding: 10px 14px;
          }

          .media-card-title {
            font-size: 14px;
          }

          .media-card-content {
            padding: 14px 14px;
          }

          .media-point-row {
            gap: 10px;
            margin-bottom: 10px;
          }

          .media-point-check {
            width: 20px;
            height: 20px;
            min-width: 20px;
          }

          .media-point-check svg {
            font-size: 9px;
          }

          .media-point-text {
            font-size: 13.5px;
            line-height: 1.6;
          }
        }

        /* Very small phones */
        @media (max-width: 360px) {
          .media-title {
            font-size: 18px;
          }

          .media-card-title {
            font-size: 13px;
          }

          .media-point-text {
            font-size: 13px;
          }
        }
      `}</style>

      <div className="media-wrapper">
        {/* HERO SECTION */}
        <div className="media-hero">
          <div className="media-hero-inner">
            <div className="media-hero-top">
              <div className="media-icon-box">
                <FaFilm />
              </div>

              <h1 className="media-title">Media & Entertainment</h1>
            </div>

            <p className="media-description">
              This industry includes content creation, distribution, broadcasting, streaming platforms, music, films, gaming, and live events. It thrives on user engagement, creativity, and personalization.
            </p>
          </div>
        </div>

        {/* ACCORDION SECTION */}
        <div className="media-accordion-wrap">
          {sections.map((section, index) => {
            const isActive = openIndex === index;
            return (
              <div key={index} className="media-card">
                {/* HEADER */}
                <div
                  onClick={() => toggle(index)}
                  className={`media-card-header ${
                    isActive ? "active" : "inactive"
                  }`}
                >
                  <h2
                    className={`media-card-title ${
                      isActive ? "active" : "inactive"
                    }`}
                  >
                    {section.title}
                  </h2>

                  {isActive ? (
                    <FaChevronUp className="media-chevron-active" />
                  ) : (
                    <FaChevronDown className="media-chevron-inactive" />
                  )}
                </div>

                {/* CONTENT */}
                {isActive && (
                  <div className="media-card-content">
                    {section.points.map((point, i) => (
                      <div key={i} className="media-point-row">
                        <div className="media-point-check">
                          <FaCheck />
                        </div>

                        <p className="media-point-text">{point}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default MediaEntertainmentPage;
